export default __webpack_public_path__ + "static/media/infection.37b894f8.svg";